import "./index.css";
import "@/i18n";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "@/app";

const root = document.getElementById("root");
if (!root) {
  throw new Error("#root element missing in index.html");
}

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
